.select {
    align-self: start;
}
